<svg
  width="47"
  height="46"
  viewBox="0 0 47 46"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M23.4894 44.3143C35.2428 44.3143 44.7708 34.886 44.7708 23.2555C44.7708 11.6251 35.2428 2.19678 23.4894 2.19678C11.736 2.19678 2.20801 11.6251 2.20801 23.2555C2.20801 34.886 11.736 44.3143 23.4894 44.3143Z"
    fill="url(#paint0_linear_852_45089)"
  />
  <path
    d="M44.2708 23.2555C44.2708 34.6049 34.9716 43.8143 23.4894 43.8143C12.0072 43.8143 2.70801 34.6049 2.70801 23.2555C2.70801 11.9062 12.0072 2.69678 23.4894 2.69678C34.9716 2.69678 44.2708 11.9062 44.2708 23.2555Z"
    stroke="#774700"
    stroke-opacity="0.5"
  />
  <path
    d="M20.1278 25.3268C18.0203 26.8654 14.2258 26.9679 11.9487 25.3268C11.4223 24.9477 10.5491 25.2109 10.7449 25.6532C12.7347 30.1611 19.3475 30.1513 21.3331 25.6532C21.5275 25.2109 20.6514 24.9442 20.1278 25.3268Z"
    fill="#1A1626"
  />
  <path
    d="M26.8447 25.3268C28.9523 26.8654 32.7467 26.9679 35.0238 25.3268C35.5502 24.9477 36.4234 25.2109 36.2277 25.6532C34.2378 30.1611 27.625 30.1513 25.6395 25.6532C25.4451 25.2109 26.3212 24.9442 26.8447 25.3268Z"
    fill="#1A1626"
  />
  <path
    d="M18.444 37.9935C21.0417 36.1874 25.7208 36.0674 28.5278 37.9935C29.1776 38.4386 30.2544 38.1297 30.0132 37.6103C27.5595 32.3196 19.4059 32.3308 16.9585 37.6103C16.7166 38.1297 17.7963 38.4428 18.444 37.9935Z"
    fill="#1A1626"
  />
  <path
    d="M11.4633 16.5417C4.51989 20.6054 8.94713 21.4849 15.2358 18.7606C18.7841 17.2233 16.0324 13.8645 11.4633 16.5417Z"
    fill="#D69600"
  />
  <path
    d="M35.5066 16.5527C30.9368 13.8769 28.1858 17.235 31.7356 18.7716C38.0256 21.4966 42.4529 20.6157 35.5066 16.5527Z"
    fill="#D69600"
  />
  <defs>
    <linearGradient
      id="paint0_linear_852_45089"
      x1="23.4894"
      y1="44.3143"
      x2="23.4894"
      y2="2.19678"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FF7B00" />
      <stop offset="0.3236" stop-color="#FFAE00" />
      <stop offset="0.6205" stop-color="#FFD600" />
      <stop offset="0.8558" stop-color="#FFEE00" />
      <stop offset="1" stop-color="#FFF700" />
    </linearGradient>
  </defs>
</svg>
